import React from 'react';
import translate from '../../i18n/translate';

/**
 * OpenInvitations — landing-page section that explicitly names the profiles
 * we want to hear from and the concrete gap each could fill. Sits between
 * the Roadmap (where-we-are) and Papers (the receipts) so the visitor
 * reads it as the natural "where-could-I-help" follow-up.
 *
 * Single contact channel: info@metha.life with a per-area subject prefix
 * (rendered in the CTA copy). Sub-aliases like economics@ / legal@ are
 * deferred to the document-format pass.
 */

const ROLES = [
  {
    id: 'economics',
    eyebrowKey:    'oi-1-eyebrow',
    titleKey:      'oi-1-title',
    gapKey:        'oi-1-gap',
    subjectPrefix: '[Economics]',
  },
  {
    id: 'legal',
    eyebrowKey:    'oi-2-eyebrow',
    titleKey:      'oi-2-title',
    gapKey:        'oi-2-gap',
    subjectPrefix: '[Legal]',
  },
  {
    id: 'regulatory',
    eyebrowKey:    'oi-3-eyebrow',
    titleKey:      'oi-3-title',
    gapKey:        'oi-3-gap',
    subjectPrefix: '[Regulatory]',
  },
  {
    id: 'research',
    eyebrowKey:    'oi-4-eyebrow',
    titleKey:      'oi-4-title',
    gapKey:        'oi-4-gap',
    subjectPrefix: '[Research]',
  },
  {
    id: 'compliance',
    eyebrowKey:    'oi-5-eyebrow',
    titleKey:      'oi-5-title',
    gapKey:        'oi-5-gap',
    subjectPrefix: '[Compliance]',
  },
  {
    id: 'code',
    eyebrowKey:    'oi-6-eyebrow',
    titleKey:      'oi-6-title',
    gapKey:        'oi-6-gap',
    subjectPrefix: '[Code]',
  },
];

const EMAIL = 'info@metha.life';

export default function OpenInvitations() {
  return (
    <section className="lv2-section lv2-oi-section" id="open-invitations" style={{ paddingTop: 0 }}>
      <div className="lv2-shell">
        <div className="lv2-section-head">
          <span className="lv2-section-tag">{translate('oi-tag')}</span>
          <h2>{translate('oi-h2')}</h2>
          <p className="sub">{translate('oi-sub')}</p>
        </div>

        <div className="lv2-oi-grid">
          {ROLES.map((r) => (
            <article key={r.id} className="lv2-oi-card">
              <span className="lv2-oi-eyebrow">{translate(r.eyebrowKey)}</span>
              <h3 className="lv2-oi-title">{translate(r.titleKey)}</h3>
              <p className="lv2-oi-gap">{translate(r.gapKey)}</p>
              <a
                className="lv2-oi-cta"
                href={`mailto:${EMAIL}?subject=${encodeURIComponent(r.subjectPrefix + ' ')}`}
              >
                <span className="lv2-oi-cta-label">{translate('oi-cta-write')}</span>
                <span className="lv2-oi-cta-email">{EMAIL}</span>
                <span className="lv2-oi-cta-prefix">{translate('oi-cta-subject')} <code>{r.subjectPrefix}</code></span>
              </a>
            </article>
          ))}
        </div>

        <p className="lv2-oi-foot">
          {translate('oi-foot-1')}{' '}
          <a className="acc" href={`mailto:${EMAIL}?subject=${encodeURIComponent('[Other] ')}`}>{EMAIL}</a>{' '}
          {translate('oi-foot-2')}
        </p>
      </div>
    </section>
  );
}
